/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Status_Missing_4Inputs */

const en_vc_status_missing_4 = /** @type {(inputs: Vc_Status_Missing_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-in generative AI features`)
};

const zh_vc_status_missing_4 = /** @type {(inputs: Vc_Status_Missing_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`内置的生成式 AI 功能`)
};

/**
* | output |
* | --- |
* | "Built-in generative AI features" |
*
* @param {Vc_Status_Missing_4Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_status_missing_4 = /** @type {((inputs?: Vc_Status_Missing_4Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Status_Missing_4Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_status_missing_4(inputs)
	return zh_vc_status_missing_4(inputs)
});
export { vc_status_missing_4 as "vc.status.missing.4" }